import { LOGOUT, SET_ACCESS_CODE, SET_ACCESS_CODES_LIST } from "../actions/types";

const INITIAL_STATE = {
    accessCode: null,
    list: {
        lifetime: {
            accessCodeID: null,
            subID: null,
            validTo: null
        },
        timed: []
    }
};

const accessCodeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ACCESS_CODE:
            return {
                ...state,
                accessCode: action.payload.accessCode
            };
        case SET_ACCESS_CODES_LIST:
            return {
                ...state,
                list: {
                    lifetime: action.payload.lifetime ? {
                        accessCodeID: action.payload.lifetime.accessCodeID,
                        subID: action.payload.lifetime.subID
                    } : INITIAL_STATE.list.lifetime,
                    timed: action.payload.timed.map(accessCode => {
                        return {
                            accessCodeID: accessCode.accessCodeID,
                            subID: accessCode.subID,
                            validTo: accessCode.validTo
                        };
                    })
                }
            };   
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default accessCodeReducer;